<template>
  <section class="container">
    <div class="main">
      <div class="header">
        <h2>Subscribe Membership</h2>
        <div class="btn">
          <v-button
            gray
            @click="handleCancel">Cancel</v-button>
          <v-button
            green
            @click="handleSubscribe">Subscribe</v-button>
        </div>
      </div>
      <el-form
        ref="form"
        :model="formData"
        :rules="rules">
        <div
          v-if="showBaseData"
          class="box">

          <div class="form form1">
            <div class="item">
              <span class="item-title">Last Name</span>
              <el-form-item
                ref="isrd_lst_nm"
                prop="isrd_lst_nm">
                <v-input
                  v-model="formData.isrd_lst_nm"
                  uppercase />
              </el-form-item>
            </div>
            <div class="item">
              <span class="item-title">First Name</span>
              <el-form-item
                ref="isrd_fst_nm"
                prop="isrd_fst_nm">
                <v-input
                  v-model="formData.isrd_fst_nm"
                  uppercase></v-input>
              </el-form-item>
            </div>
            <div class="item">
              <span class="item-title">Date of Birth</span>
              <el-form-item
                ref="isrd_dob"
                prop="isrd_dob">
                <v-birth-day
                  v-model="formData.isrd_dob"
                  class="birth"></v-birth-day>
              </el-form-item>
            </div>
            <div class="item">
              <span class="item-title">HKID</span>
              <el-form-item
                ref="id_no"
              >
                <v-input v-model="formData.id_no"></v-input>
              </el-form-item>
            </div>
          </div>

        </div>

        <div
          v-if="showQuestion"
          class="box">
          <!--        <el-form-->
          <!--          ref="form2"-->
          <!--          class="form form2"-->
          <!--          :model="form2"-->
          <!--          :rules="rules2">-->
          <div class="form form2">
            <div class="item">
              <span class="item-title">Is referrer allowed to provide any insurance advice to policyholder?</span>
              <v-radio-group
                v-model="formData.q_1"
                :list="yesNoOptions" />
            </div>
            <div class="item">
              <span class="item-title">Could referrer assist policyholder to input the insurance application information?</span>
              <v-radio-group
                v-model="formData.q_2"
                :list="yesNoOptions" />
            </div>
            <div class="item">
              <span class="item-title">Who can make the final decision on which insurance plan to apply for?</span>
              <v-radio-group
                v-model="formData.q_3"
                :list="p_r_options" />
            </div>
            <div class="item">
              <span class="item-title">Who should confirm the insurance application information and make the premium payment?</span>
              <v-radio-group
                v-model="formData.q_4"
                :list="p_r_options" />
            </div>
            <div class="item">
              <span class="item-title">Who should give insurance advices regarding policy enquiry & claims?</span>
              <v-radio-group
                v-model="formData.q_5"
                :list="cs_r_options" />
            </div>
          </div>
          <!--        </el-form>-->
        </div>

        <div class="box">
          <!--        <el-form-->
          <!--          ref="formData"-->
          <!--          -->
          <!--          :model="formData"-->
          <!--          :rules="rules">-->
          <div class="form formData">
            <!--            <div class="item">-->
            <!--              <el-form-item-->
            <!--                ref="renewal_type"-->
            <!--                :rules="rules.select"-->
            <!--                prop="renewal_type">-->
            <!--                <el-radio-->
            <!--                  v-model="formData.renewal_type"-->
            <!--                  label="2">Annual plan with one-off payment</el-radio>-->
            <!--                <div class="tips">$3000/yr (2 months rebate)</div>-->
            <!--              </el-form-item>-->
            <!--            </div>-->
            <!--            <div class="item">-->
            <!--              <el-form-item-->
            <!--                ref="renewal_type"-->
            <!--                :rules="rules.select"-->
            <!--                prop="renewal_type">-->
            <!--                <el-radio-->
            <!--                  v-model="formData.renewal_type"-->
            <!--                  label="1">Annual plan with monthly payment</el-radio>-->
            <!--                <div class="tips">$300/month</div>-->
            <!--              </el-form-item>-->
            <!--            </div>-->
            <div class="item">
              <span class="item-title">Invitation Code</span>
              <el-form-item prop="code">
                <v-input
                  v-model="formData.team_code"
                  append="Apply" />
              </el-form-item>
            </div>
            <div class="item">
              <span class="item-title">Trail Code</span>
              <el-form-item prop="code">
                <v-input
                  v-model="formData.code"
                  append="Apply" />
              </el-form-item>
            </div>
          </div>
          <!--        </el-form>-->
        </div>

        <!--        <div class="box">-->
        <!--          &lt;!&ndash;        <el-form&ndash;&gt;-->
        <!--          &lt;!&ndash;          class="form formData"&ndash;&gt;-->
        <!--          &lt;!&ndash;          :model="formData"&ndash;&gt;-->
        <!--          &lt;!&ndash;          :rules="rules">&ndash;&gt;-->
        <!--          <div class="form formData">-->
        <!--            <div class="item">-->
        <!--              <span class="item-title">Name</span>-->
        <!--              <el-form-item  prop="cardHolderName">-->
        <!--                <v-input-->
        <!--                  v-model="formData.cardHolderName"-->
        <!--                  uppercase></v-input>-->
        <!--              </el-form-item >-->
        <!--            </div>-->
        <!--            <div class="item">-->
        <!--              <span class="item-title">Credit Card</span>-->
        <!--              <el-form-item>-->
        <!--                <div id="card-element"></div>-->
        <!--              </el-form-item>-->
        <!--            </div>-->
        <!--            <p-->
        <!--              id="card-errors"-->
        <!--              style="color: red"></p>-->
        <!--          </div>-->
        <!--        </div>-->
      </el-form>
      <div class="footer">
        <v-button
          gray
          @click="handleCancel">Cancel</v-button>
        <v-button
          green
          @click="handleSubscribe">Subscribe</v-button>
      </div>
    </div>
    <aside>
      <div class="box-remark">
        <span class="title">Remarks</span>
        <div class="remarks-container">
          <div
            v-for="(item, index) in remarkLogsData"
            :key="index"
            class="remark-box">
            <div class="remark-header">
              <span>{{ item.agent }}</span>
              <span>{{ item.created_at }}</span>
            </div>
            <p>{{ item.message }}</p>
          </div>
        </div>
        <div class="remark-add">
          <v-input
            v-model="message"
            class="mg-b-15"
            append="Add"
            @handlerAppend="handlerRemark"/>
        </div>
      </div>
    </aside>
    <send-email-sms
      ref="send-email-sms"
      :form="customer_profile"
      :is-edit="true"
      :initContent="initContent"
      :emailListTitle="emailListTitle"
      :emailTitle="emailTitle"
      @skip="handlerSkip"
      @send="handlerSend" />
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import {vipSubscribe} from '@api/referral'
import MixinRules from '@/mixins/rules'
import {addAccountRemark} from '@api/account'
import SendEmailSms from '@/views/components/dialogs/send-email-sms'

const env = require('../../../../env')

export default {
  name: 'SubscribeMembership',
  components:{
    SendEmailSms
  },
  mixins: [MixinOptions,MixinRules],
  props:{
    form:{
      type:Object,
      default:()=>({})
    },
    customer:{
      type:Object,
      default:()=>({})
    },
    remark:{
      type:Array,
      default:()=>([])
    }
  },
  data () {
    return {
      formData:{
        isrd_lst_nm:'',
        isrd_fst_nm:'',
        isrd_dob:'',
        id_no:'',
        q_1:0,
        q_2:1,
        q_3:1,
        q_4:1,
        q_5:1,
        // card_token:'',
        renewal_type:'2',
        code:'90TRAIL',
        team_code:'',
        // cardHolderName:''
      },
      message:'',
      p_r_options:[
        {
          id: 1,
          name: 'Policyholder'
        },
        {
          id: 2,
          name: 'Referrer'
        },
      ],
      cs_r_options:[
        {
          id: 1,
          name: 'HoldCover CS'
        },
        {
          id: 2,
          name: 'Referrer'
        },
      ],
      stripe: null,
      cardElement: null,
      remarkList: [],
      lock:false,
      cardInputComplete:false,
      is_send:0
    }
  },
  computed:{
    customer_profile(){
      let customer_profile = this.customer||{}
      let {isrd_lst_nm,isrd_fst_nm} = this.formData
      let {isrd_nm,nick_name} = customer_profile
      if(!isrd_nm) {
        customer_profile.isrd_lst_nm = isrd_lst_nm
        customer_profile.isrd_fst_nm = isrd_fst_nm
      }
      if(nick_name){
        customer_profile.isrd_nm = nick_name
      }
      return customer_profile
    },
    remarkLogsData(){
      return this.remarkList||[]
    },
    is_tier_base(){
      let {is_tier_base=false} = this.customer
      return is_tier_base
    },
    showBaseData(){
      let{id_no=''} = this.customer
      return !id_no&&this.is_tier_base==false
    },
    showQuestion(){
      let{tier_base_renewed=false} = this.customer
      return tier_base_renewed==false&&this.is_tier_base==false
    },
    customerId() {
      return this.$route.query.customer_id
    },
    emailListTitle(){
      let {success_upgraded_list_title}  = this.form||{}
      return success_upgraded_list_title
    },
    emailTitle(){
      let {success_upgraded_title}  = this.form||{}
      return success_upgraded_title
    },
    initContent(){
      let {success_upgraded_data}  = this.form||{}
      return success_upgraded_data
    },

  },
  mounted(){
    // this.stripe = null
    this.remarkList = this.remark
    // this.initPay()
  },
  methods: {
    handlerSkip(){
      let params ={
        content:'',
        is_send:0
      }
      this.handleSubscribeSend(params)
    },
    handlerSend(content){
      let params ={
        content:content,
        is_send:1
      }
      this.handleSubscribeSend(params)
    },
    handleCancel(){
      this.$parent.showSubscribe = false
    },
    initPay() {
      // eslint-disable-next-line
      this.stripe = Stripe(env.PAY_KEY);
      const elements = this.stripe.elements({ locale: 'en' }) //// 设置默认显示语种   en 英文 cn 中文 auto 自动获取语种
      const style = {
        base: {
          // Add your base input styles here. For example:
          fontSize: '16px',
          color: '#32325d',
        },
      }
      this.cardElement = elements.create('card', {
        style,
        disabled: false,
        hidePostalCode: true,
      })

      this.cardElement.mount('#card-element')
      //  觸發表單校驗
      this.cardElement.addEventListener('change', (data) => {
        const displayError = document.getElementById('card-errors')
        console.log('asdad',data)
        let {error,complete} = data
        this.cardInputComplete = complete
        if (error) {
          displayError.textContent = error.message
        } else {
          displayError.textContent = ''
        }
      })




      // const cardButton = document.getElementById('card-button')
      // cardButton.addEventListener('click', (ev) => {
      //   this.$refs.form.validate((valid) => {
      //     if (valid) {
      //       console.log(ev)
      //
      //       if (this.lock) return
      //
      //       this.lock = true // 禁用按鈕
      //
      //       // 額外參數
      //       let extraData = {
      //         billing_details: {},
      //       }
      //       if (this.formData.cardHolderName) {
      //         extraData.billing_details.name = this.formData.cardHolderName
      //       }
      //
      //       this.stripe
      //         .createToken(this.cardElement)
      //         .then((result) => {
      //           console.log('createToken',result)
      //           if (result.error) {
      //             // Show error in payment form
      //             this.$message(result.error.message)
      //             this.lock = false
      //           } else {
      //             let resultParams = {
      //               // payment_method_id: result.paymentMethod.id,
      //               // order_id: this.orderId,
      //             }
      //
      //           }
      //         })
      //     }
      //   })
      // })
      //
      // this.stripe
      //   .createToken(this.cardElement)
      //   .then((result) => {
      //     console.log('createToken',result)
      //     if (result.error) {
      //       // Show error in payment form
      //       this.$message(result.error.message)
      //       this.lock = false
      //     } else {
      //       let resultParams = {
      //         // payment_method_id: result.paymentMethod.id,
      //         // order_id: this.orderId,
      //       }
      //
      //     }
      //   })
    },

    handlerRemark() {
      if (this.message) {
        this.network().addAccountRemark()
      }
    },
    handleSubscribe(){

      this.$refs.form.validate( (valid) => {
        if (valid) {
          // 額外參數
          this.$refs['send-email-sms'].changeDialog()
        }

      })
    },
    async handleSubscribeSend(params){
      let extraData = {}
      let {cardHolderName,code} = this.formData
      // if (cardHolderName) {
      //   extraData = {
      //     name: cardHolderName,
      //   }
      // }
      if(!code)
      {
        // let result = await this.stripe.createToken(this.cardElement,extraData)
        // this.formData.card_token = result.token.id
      }
      this.network().vipSubscribe({

        ...this.formData,
        ...params,
        user_id:this.customerId,
      })
    },
    network() {
      return {
        vipSubscribe: async (params) => {
          const { data } = await vipSubscribe(params)
          this.$parent.getUpdateAccountData()
          this.$parent.showSubscribe = false
        },
        addAccountRemark: async () => {
          const {data} = await addAccountRemark({
            customer_id: this.customerId,
            message: this.message
          })
          this.message = ''
          this.remarkList.unshift(data)
        }
      }
    },
  },
}
</script>
<style lang='scss' scoped>
.container{
  display: flex;
  padding: 0 70px;
  margin-top: 20px;
  min-height: calc(100vh - 150px);
  .main{
    margin-right: 30px;
    flex: 1;
    .header{
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
      h2{
        padding: 0;
        font-weight: 600;
        font-size: 20px;
        color: #24292E;
      }
    }
    .box{
      padding-bottom: 30px;
      border-bottom: 1px solid #D1D5DA;
      margin-bottom: 30px;
      .form{
        .item{
          .item-title{
            font-weight: 600;
            font-size: 14px;
            color: #24292E;
            margin-bottom: 8px;
            display: inline-block;
          }
          & + .item{
            margin-top: 20px;
          }
        }
      }
      .form1, .formData{
        width: 330px;
      }
      .tips{
        padding-left: 24px;
        margin-top: 4px;
        font-weight: 400;
        font-size: 14px;
        color: #24292E;
      }
    }
    .footer{
      display: flex;
      justify-content: space-between;
      padding-bottom: 30px;
    }
  }
  aside{
    width: 280px;
    .box-remark{
      .title{
        font-weight: 600;
        font-size: 14px;
        color: #24292E;
      }
      .remarks-container {
        z-index: 1;
        max-height: 300px;
        overflow-y: auto;

        .remark-box {
          margin-bottom: 10px;
          font-size: 12px;
          color: #91939a;

          .remark-header {
            display: flex;
            justify-content: space-between;

            span:first-child {
              font-weight: bold;
            }
          }

          p {
            padding-bottom: 10px;
            color: #616266;
          }
        }
      }
      .remark-add {
        z-index: 2;
        margin: 0 -15px;
        padding: 15px 15px 0 15px;
      }
    }
  }
  /deep/.birth{
    .year{
      width: 140px;
      margin-right: 0;
    }
  }
  /deep/.el-radio-group{
    display: flex;
    flex-direction: column;
  }
  /deep/.el-radio{
    font-weight: 600;
    font-size: 14px;
    color: #24292E;
    & + .el-radio{
      margin-top: 4px;
    }
  }
}
</style>
